import { t } from "@/i18n-js/instance";
import { useCurrentLessonContext } from "@/react/contexts/currentLessonContext";
import { LessonSettings } from "./LessonSettings";
import { QuizSettings } from "./QuizSettings";

export const SettingsField = () => {
  const { currentLesson } = useCurrentLessonContext();
  const isQuiz = Boolean(currentLesson?.quiz);
  return (
    <div className="form-group">
      <label className="form-group__label text-dark flex cursor-default">
        <span>{t("courses.edit.lesson.settings")}</span>
      </label>
      {isQuiz ? <QuizSettings /> : <LessonSettings />}
    </div>
  );
};
